module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-30"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Deliverer"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pz30-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ba_07",
      "id": "ab_07"
    }
  }, [_c('b', [_vm._v("Deliverer")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-3"
    }
  }, [_vm._v("The Spirit of the Lord G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")]), _vm._v(" is upon Me,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-4"
    }
  }, [_vm._v("Because the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" has anointed Me")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-5"
    }
  }, [_vm._v("To preach good tidings to the poor;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-6"
    }
  }, [_vm._v("He has sent Me to heal the brokenhearted,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-7"
    }
  }, [_vm._v("To proclaim liberty to the captives,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-8"
    }
  }, [_vm._v("And the opening of the prison to those who are bound.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz30-10"
    }
  }, [_c('em', [_vm._v("Isaiah 61:1")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-11"
    }
  }, [_vm._v("And you shall know the truth, and the truth shall make you free.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-12"
    }
  }, [_vm._v("Therefore if the Son makes you free, you shall be free indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz30-13"
    }
  }, [_c('em', [_vm._v("John 8:32, 36")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-14"
    }
  }, [_vm._v("For the law of the Spirit of life in Christ Jesus has made me free from the law of sin and death.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz30-15"
    }
  }, [_c('em', [_vm._v("Romans 8:2")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-16"
    }
  }, [_vm._v("Behold, I give you the authority to trample on serpents and scorpions, and over all the power of the enemy, and nothing shall by any means hurt you.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz30-17"
    }
  }, [_c('em', [_vm._v("Luke 10:19")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-1"
    }
  }, [_vm._v("Now the Lord is the Spirit; and where the Spirit of the Lord is, there is liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Aqd"
    }
  }, [_c('em', [_vm._v("II Corinthians 3:17")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-2"
    }
  }, [_vm._v("But now having been set free from sin, and having become slaves of God, you have your fruit to holiness, and the end, everlasting life.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz31-3"
    }
  }, [_c('em', [_vm._v("Romans 6:22")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-4"
    }
  }, [_vm._v("For You have broken the yoke of his burden")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-5"
    }
  }, [_vm._v("And the staff of his shoulder,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-6"
    }
  }, [_vm._v("The rod of his oppressor,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-7"
    }
  }, [_vm._v("As in the day of Midian.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz31-8"
    }
  }, [_c('em', [_vm._v("Isaiah 9:4")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-9"
    }
  }, [_vm._v("The Spirit of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" is upon Me,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-10"
    }
  }, [_vm._v("Because He has anointed Me to preach the gospel to the poor;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-12"
    }
  }, [_vm._v("He has sent Me to heal the brokenhearted,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-13"
    }
  }, [_vm._v("To proclaim liberty to the captives")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-14"
    }
  }, [_vm._v("And recovery of sight to the blind,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-15"
    }
  }, [_vm._v("To set at liberty those who are oppressed.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz31-16"
    }
  }, [_c('em', [_vm._v("Luke 4:18")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-17"
    }
  }, [_vm._v("And these signs will follow those who believe: In My name they will cast out demons; they will speak with new tongues.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz31-18"
    }
  }, [_c('em', [_vm._v("Mark 16:17")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-1"
    }
  }, [_vm._v("And they overcame him by the blood of the Lamb and by the word of their testimony, and they did not love their lives to the death.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "AFQh"
    }
  }, [_c('em', [_vm._v("Revelation 12:11")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-2"
    }
  }, [_vm._v("Beloved, do not believe every spirit, but test the spirits, whether they are of God; because many false prophets have gone out into the world.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-3"
    }
  }, [_vm._v("By this you know the Spirit of God: Every spirit that confesses that Jesus Christ has come in the flesh is of God,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-4"
    }
  }, [_vm._v("and every spirit that does not confess that Jesus Christ has come in the flesh is not of God. And this is the spirit of the Antichrist, which you have heard was coming, and is now already in the world.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-5"
    }
  }, [_vm._v("You are of God, little children, and have overcome them, because He who is in you is greater than he who is in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz32-6"
    }
  }, [_c('em', [_vm._v("1 John 4:1–4")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7735866","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter07.vue
// module id = 93
// module chunks = 0